import { t } from 'i18next'
import * as yup from 'yup'

import { BIND_TYPE, TIME_LINE_MODE } from '@constants'

const isObjectMode = (mode: { id?: string } | null) => mode?.id === TIME_LINE_MODE.OBJECT

const requiredIdLabelShape = {
  id: yup
    .string()
    .nullable()
    .test('required', '', (val?: string | null) => Boolean(val?.trim())),
  label: yup.string().test('required', '', (val?: string) => Boolean(val?.trim())),
}

export const timelineObjectXConfiguration = yup.object().shape({
  object: yup.object().shape({
    id: yup
      .string()
      .nullable()
      .test('required', '', val => Boolean(val?.trim())),
    label: yup.string().test('required', '', val => Boolean(val?.trim())),
  }),
  startDateField: yup.object().when(['$mode'], {
    is: (mode: { id?: string } | null) => isObjectMode(mode),
    then: schema => schema.optional().nullable(),
    otherwise: schema => schema.shape(requiredIdLabelShape),
  }),
  endDateField: yup.object().when(['$mode'], {
    is: (mode: { id?: string } | null) => isObjectMode(mode),
    then: schema => schema.optional().nullable(),
    otherwise: schema =>
      schema.shape({
        id: yup.string().test('required', '', (val?: string) => Boolean(val?.trim())),
        label: yup.string().test('required', '', (val?: string) => Boolean(val?.trim())),
      }),
  }),
  linkToObjectY: yup.object().shape({
    keyField: yup
      .string()
      .nullable()
      .test('required', '', (val?: string | null) => Boolean(val?.trim())),
  }),
  linkToColumnsObject: yup.object().when(['$mode'], {
    is: (mode: { id?: string } | null) => isObjectMode(mode),
    then: schema =>
      schema.shape({
        keyField: yup
          .string()
          .nullable()
          .test('required', '', (val?: string | null) => Boolean(val?.trim())),
      }),
    otherwise: schema => schema.optional().nullable(),
  }),
  fieldFromColumnsObjectToLink: yup.object().when(['$mode'], {
    is: (mode: { id?: string } | null) => isObjectMode(mode),
    then: schema =>
      schema.shape({
        keyField: yup
          .string()
          .nullable()
          .test('required', '', (val?: string | null) => Boolean(val?.trim())),
      }),
    otherwise: schema => schema.optional().nullable(),
  }),
  fieldFromObjectYToLink: yup.object().when(['$mode'], {
    is: (mode: { id?: string } | null) => isObjectMode(mode),
    then: schema =>
      schema.shape({
        keyField: yup
          .string()
          .nullable()
          .test('required', '', (val?: string | null) => Boolean(val?.trim())),
      }),
    otherwise: schema => schema.optional().nullable(),
  }),
  columnsObject: yup.object().when(['$mode'], {
    is: (mode: { id?: string } | null) => isObjectMode(mode),
    then: schema =>
      schema.shape({
        object: yup.object().shape(requiredIdLabelShape),
        command: yup.object().shape({
          name: yup.object().shape(requiredIdLabelShape),
        }),
        headerBindType: yup.object().shape(requiredIdLabelShape),
        headerField: yup.object().when('headerBindType', {
          is: (val: { id?: string } | null) => val?.id === BIND_TYPE.FIELD,
          then: schema =>
            schema.shape({
              keyField: yup
                .string()
                .nullable()
                .test('required', '', (val?: string | null) => Boolean(val?.trim())),
            }),
          otherwise: schema => schema.optional().nullable(),
        }),
        headerScript: yup.string().when('headerBindType', {
          is: (val: { id?: string } | null) => val?.id !== BIND_TYPE.FIELD,
          then: schema => schema.test('required', '', (val?: string) => Boolean(val?.trim())),
          otherwise: schema => schema.optional().nullable(),
        }),
      }),
    otherwise: schema => schema.optional().nullable(),
  }),
  getDataCommand: yup.object().shape({
    name: yup.object().shape({
      id: yup
        .string()
        .required()
        .test('required', '', val => Boolean(val?.trim())),
      label: yup
        .string()
        .required()
        .test('required', '', val => Boolean(val?.trim())),
    }),
  }),
  cell: yup.object().shape({
    value: yup
      .string()
      .test('required', t('timeLinesCreateOrEdit.objectX.cell.scriptRequired'), val =>
        Boolean(val?.trim())
      ),
    bindType: yup.object().shape({
      id: yup.string().test('required', '', val => Boolean(val?.trim())),
      label: yup.string().test('required', '', val => Boolean(val?.trim())),
    }),
  }),
  totalsRows: yup.array(
    yup.object().shape({
      title: yup.string().test('required', '', val => Boolean(val?.trim())),
      script: yup.string().test('required', '', val => Boolean(val?.trim())),
      bindType: yup.object().shape({
        id: yup.string().test('required', '', val => Boolean(val?.trim())),
        label: yup.string().test('required', '', val => Boolean(val?.trim())),
      }),
      commands: yup.array(yup.object().shape({})),
    })
  ),
})
export const timelineObjectYConfiguration = yup.object().shape({
  object: yup.object().shape({
    id: yup.string().test('required', '', val => Boolean(val?.trim())),
    label: yup.string().test('required', '', val => Boolean(val?.trim())),
  }),
  keyField: yup.object().shape({
    id: yup.string().test('required', '', val => Boolean(val?.trim())),
    label: yup.string().test('required', '', val => Boolean(val?.trim())),
  }),
  getDataCommand: yup.object().shape({
    name: yup.object().shape({
      id: yup
        .string()
        .required()
        .test('required', '', val => Boolean(val?.trim())),
      label: yup
        .string()
        .required()
        .test('required', '', val => Boolean(val?.trim())),
    }),
  }),
})

export const timelineConfigurationSchema = yup.object().shape({
  code: yup.string().test('required', '', val => Boolean(val?.trim())),
  title: yup.string().test('required', '', val => Boolean(val?.trim())),
  objectX: timelineObjectXConfiguration,
  objectY: timelineObjectYConfiguration,
})
